export function setCookie(name: string, value: string, days: number): void {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/`;
}

export function setCookieInMinutes(name: string, value: string, minutes: number): void {
  const d = new Date();
  d.setTime(d.getTime() + minutes * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/`;
}

export function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}
 
export function getJsonCookie(name: string): any | null {
  try {
    const raw = getCookie(name);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.error(`Error parsing cookie "${name}":`, e);
    return null;
  }
}

export function deleteAllCookies(): void {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  }
}

export function deleteCookieByName(name: string): void {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}

export function deleteCookiesEndingWith(suffix: string): void {
  const cookies = document.cookie.split(";");

  cookies.forEach(cookie => {
    const cookieName = cookie.split("=")[0].trim();
    if (cookieName.endsWith(suffix)) {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    }
  });
}

export function getTokenExpiry(token: string): number {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000; // convert to ms
  } catch {
    return 0;
  }
}

export function isTokenExpired(token: string, bufferSeconds: number = 120): boolean {
  const expiry = getTokenExpiry(token); // get "exp" claim (in ms)
  if (!expiry) return true;             // if no expiry found → treat as expired
  const now = Date.now();               // current time (in ms)

  // If current time is beyond (expiry - bufferSeconds), token is expired/near expiry
  return now >= (expiry - bufferSeconds * 1000);
}